import { useState } from "react";
import { faCartShopping, faClose, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

import { formatImageUrl } from "../../_helpers/route-image";
import { useProduct } from "../../../services/products/product.context";


export const CartAddForm = ({ itemData, closeCart, cart }) => {
    const cartItem = cart?.find((obj) => obj._id === itemData?._id);
    const discount = itemData?.pricing?.discount;
    const cost = itemData?.pricing?.original_cost;

    const navigateTo = useNavigate();

    const [quantity, setQuantity] = useState(cartItem?.quantity || 1);

    const { addToCart } = useProduct();



    const increment = () => setQuantity((v) => v + 1)
    const decrement = () => {
        if (quantity === 1) return;
        setQuantity((v) => v - 1);
    }


    const inCart = cart?.some((item) => item?._id === itemData?._id);

    const handleCheckout = (item) => {
        const productList = [ {
                designation: item?.designation,
                quantity,
                price:
                    (item?.pricing?.original_cost - item?.pricing?.original_cost * item?.pricing?.discount) * quantity
        }];
        navigateTo("/checkout", {
            state: {
                products: productList,
                total: productList[0].price
            }
        });
    }




    return (
        <div
            className="cart-item-container card-add-container"
        >
            <div className="slogan-1">{inCart ? "Retirer du " : "Ajouter au "} Panier</div>
            <div className="cart-object">
                <div className="remove-container">
                    <button
                        className="remove-cart-button"
                        onClick={closeCart}
                    >
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
                <img src={formatImageUrl(itemData?.images[0])} alt="" className="cart-item-img" />
                <div className="cart-item-infos">
                    <div className="cart-item-name">{itemData?.designation}</div>
                    <div className="cart-item-prices">
                        {discount > 0 && (
                            <strike>
                                <div className="cart-item-old-price">
                                    FCFA {cost.toLocaleString()}
                                </div>
                            </strike>
                        )}
                        <div className="cart-item-cost">
                            FCFA {(cost - discount * cost).toLocaleString()}
                        </div>
                    </div>
                </div>
            </div>
            <div className="cart-object-actions">
                <div className="quantity-area">
                    <button className="q-button" onClick={decrement}>
                        <FontAwesomeIcon icon={faMinus} />
                    </button>
                    <input
                        type="number"
                        onChange={(e) => setQuantity(e.target.value)}
                        value={quantity}
                        className="q-input"
                    />
                    <button className="q-button" onClick={increment}>
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                </div>
                <div className="item-sub-total">
                    <span className="sub-caption">Sub-Total</span>
                    <span className="sub-amount">FCFA {((cost - discount * cost) * quantity).toLocaleString()}</span>
                </div>
            </div>
            <div className="order-button-box">
                <button
                    className="order-button"
                    onClick={() => {
                        addToCart(itemData, quantity);
                        closeCart();
                    }}
                >
                    <span className="button-caption">
                        {inCart ? "Retirer" : "Ajouter"}
                    </span>
                    <FontAwesomeIcon icon={faCartShopping} />
                </button>
                <button 
                    className="order-button gr-btn"
                    onClick={() => {
                        handleCheckout(itemData);
                        closeCart();
                    }}
                >
                    Commandez maintenant
                </button>
            </div>
        </div>
    )
}